// material-ui
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
// styles
import styles from "./styles";

const useStyles = makeStyles(styles);

// The app's ScoreTile (lib/ui/atoms/scoreTile.dart): a square with a hairline,
// the score centred, and the tiebreak points as a superscript top-right.
//
// Every colour is passed in rather than derived here — a set tile and a
// current-game tile share this shape but nothing else.
export default function ScoreTile({
  value = "",
  exponent = "",
  size = 44,
  bgColor,
  borderColor,
  textColor,
}) {
  const classes = useStyles(styles);

  return (
    <div className={classes.tilePad}>
      <div
        className={classes.tile}
        style={{
          width: size,
          height: size,
          background: bgColor,
          borderColor,
          color: textColor,
          fontSize: Math.round(size * 0.32),
        }}
      >
        {value}
        {exponent ? (
          <span
            className={classes.exponent}
            style={{ fontSize: Math.round(size * 0.28) }}
          >
            {exponent}
          </span>
        ) : null}
      </div>
    </div>
  );
}
